import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { DeheadingSampleJobResponse } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { DeheadingQaQcDto } from '../dto/deheading-qa-qc.dto';
import { DeheadingSampleAdapter } from '../dto/deheading-sample.adpater';
import { DeHeadingSampleDto } from '../dto/deheading-sample.dto';
import { LogIdRequest } from '../dto/log-id-request';
import { DeheadingQAQCRepository } from '../repositories/deheading-qaqc.repository';
import { DeheadingSampleRepository } from '../repositories/deheading-sample.repository';

@Injectable()
export class DeheadingSampleService {
    constructor(private repo: DeheadingQAQCRepository, private adapter: DeheadingSampleAdapter) { }

    async CreateSampleInfo(dto: DeheadingQaQcDto):Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            // need to Generate Sample Unique Number;
            let sampleCode;
            if (!dto.deheadingQAQCId) {
                const totalSamples = await this.repo.count();
                let refNo = totalSamples + "";
                while (refNo.length < 4) refNo = "0" + refNo;
                sampleCode = "DeheadSample" + ((new Date()).getFullYear().toString().substr(-2)) + "/" + refNo;
                dto.sampleCode = sampleCode;
            }
            console.log(dto);
            
            // convert dto to entity
            const convertedEntity = this.adapter.convertDtoToEntity(dto);
            await manager.startTransaction();
            const saveEntity = await manager.getCustomRepository(DeheadingQAQCRepository).save(convertedEntity);
            if (saveEntity) {
                manager.completeTransaction();
                return new CommonResponse(true, 1111, "Sample created Successfully")
            } else {
                throw new ErrorResponse(9999, 'Failed to Create');
            }
        } catch (error) {
            console.log(error);
            await manager.releaseTransaction();
            return error;
        }
    }

    async getSamplesInfoByLogId(req:LogIdRequest):Promise<DeheadingSampleJobResponse> {
        try{
            const logInfo = await this.repo.getSamplesInfoByLogId(req);
            if(logInfo){
                return new DeheadingSampleJobResponse(true, 1111, 'Data Found Successfully', logInfo)
            }else{
                return new DeheadingSampleJobResponse(false, 9999, 'No Data Found',)
            }
        }catch(error){
            return error;
        }
    }
}
